import { defaultErrorResponses, problemResponse, registry } from "../registry.js";
import { REFS_BATCH_MAX, RefsQuery, RefsResponse } from "./schemas.js";

// The names read (spec 16 §3.13; P3-UX UP6, D-441). One GET, no writes. It is
// a platform route group like `files`, `audit` and `saved-views` because it
// answers for nine kinds owned by five modules, and each kind is answered by
// its owner's service, never by this route reading their tables.

registry.registerPath({
  method: "get",
  path: "/v1/refs",
  operationId: "resolveRefs",
  tags: ["refs"],
  summary: "Name a batch of references from other modules",
  description:
    "Turns up to " +
    String(REFS_BATCH_MAX) +
    " `<kind>:<uuid>` references (repeat `ref`) into names. Each kind is answered by the module that owns it and only " +
    "for a caller who holds one of that kind's read codes (`REF_KIND_READ_CODES`): `identity.view_members` or " +
    "`identity.view_member_names` for user and agent, " +
    "`identity.view_org` for facility and work_center, `catalogue.read` for product, `inventory.read` for stock_unit, " +
    "lot and location, and `sales.read` for customer. The answer is scoped as the owning module's own read would be: " +
    "the facilities of the grants that carry a code, and for a customer the sales assignment narrowing. A reference " +
    "that does not exist, belongs to another tenant, lies outside that scope, or is of a kind the caller may not read " +
    "is absent from `items`, and the four cases look the same, so the read never confirms that an id exists. " +
    "Session-scoped: no code of its own, because the gate is per kind.",
  security: [{ sessionCookie: [] }],
  request: { query: RefsQuery },
  responses: {
    ...defaultErrorResponses(),
    200: {
      description: "The references the caller may see, named",
      content: { "application/json": { schema: RefsResponse } },
    },
    400: problemResponse(
      `VALIDATION_FAILED — no \`ref\`, a malformed one, an unknown kind, or more than ${String(REFS_BATCH_MAX)}`,
    ),
  },
});
